// https://github.com/nayaabkhan/react-polyglot

const getPhrases = () => ({
	de: {
		no_title: 'Unbenannter Eintrag',
		settings: {
			settings: 'Einstellungen',
			profile_tab: 'Profil',
			team_tab: 'Team',
			users_tab: 'Benutzer',
			achievements_tab: 'Erfolge',
			groups_tab: 'Gruppen',
			access_tab: 'Zugriffsrechte',
			billing_tab: 'Bezahlung',
			team_settings: 'Team-Einstellungen',
			manage_members: 'Benutzer verwalten',
			invite_user: 'Benutzer einladen',
			invite_users: 'Benutzer einladen',
			invite_new_users: 'Neue Benutzer einladen',
			switch_team: 'Team wechseln',
			create_team: 'Team erstellen',
			create_new_team: 'Neues Team erstellen',
			edit_profile: 'Bearbeite dein Profil',
			theme: 'Dunkelmodus',
			theme_description: 'Weil es nachts kälter ist, als draußen.',
			reports: 'E-Mail-Benachrichtigungen',
			reports_description:
				'Wir benachrichtigen dich regelmäßig über neue, möglicherweise veraltete und populäre/unpopuläre Einträge.',
			update_profile: 'Profil aktualisieren',
			sign_out: 'Abmelden',
			user: 'Benutzer',
			user_description:
				'Standardmäßig können Benutzer neue Benutzer einladen, können aber nicht die Rollen oder Rechte anderer Benutzer verwalten.',
			billing_admin: 'Rechnungsbeauftragter',
			billing_admin_description:
				'Wie normale Benutzer, aber mit der Möglichkeit, die Zahlungsdaten zu verwalten.',
			admin: 'Admin',
			admin_description:
				'Admins können neue Benutzer einladen und alle Rollen und Rechte verwalten.',
			name: 'Name',
			status: 'Status',
			role: 'Rolle',
			invite_pending: 'Ausstehend',
			active: 'Aktiv',
			you: 'Du',
			resend_invitation: 'Einladung erneut senden',
			copy_link: 'Link kopieren',
			delete_invitation: 'Einladung löschen',
			delete_invitation_text:
				'Du bist dabei, diese Einladung zu löschen.',
			delete_invitation_notice: 'Diese Aktion ist unwiderruflich!',
			delete_user: 'Benutzer löschen',
			delete_user_text: 'Du bist dabei, diesen Benutzer zu löschen: ',
			delete_user_notice:
				'Diese Aktion ist unwiderruflich! Vom Benutzer erstellte Inhalte werden NICHT gelöscht.',
			really_delete_invitation: 'Einladung wirklich löschen?',
			really_delete_user: 'Benutzer wirklich löschen?',
			send_invites: 'Einladungen senden',
			invites_large_team_text:
				'Großes Team? Füge einfach mehrere E-Mail Adressen, separiert durch ein Komma oder Semikolon in das E-Mail-Feld ein.',
			invites_large_team_link: '+ Weiteren Benutzer einladen',
			auto_join: 'Automatischer Beitritt',
			auto_join_description:
				'Der automatische Beitritt ist für Ihr Team deaktiviert. Teammitglieder müssen manuell eingeladen werden.',
			team_domains: 'Domains',
			team_domains_description:
				'Dies ist eine Liste der Domains, die dein Team standardmäßig akzeptiert. Sie wird für den automatischen Beitritt, aber auch für SSO verwendet, falls ihr das eingerichtet habt. Dies ist eine sensible Einstellung und sollte nicht leichtfertig geändert werden.',
			team_domains_notice:
				'Öffentliche Domains (z.B.: gmail.com, hotmail.com,...) werden nicht akzeptiert.',
			team_domains_placeholder: 'Liste von kommaseparierten Domains',
			upload_logo: 'Logo hochladen',
			logo_light_requirements:
				'Lade ein Logo (SVG, PNG, JPG) hoch, welches am besten auf einem hellen Hintergrund funktioniert.',
			logo_dark_requirements:
				'Lade ein Logo (SVG, PNG, JPG) hoch, welches am besten auf einem dunklen Hintergrund funktioniert.',
			color_title: 'Farbe',
			favicon_title: 'Favicon',
			upload_favicon: 'Icon hochladen',
			favicon_requirements:
				'Lade ein 32 x 32 Pixel großes Icon (PNG, JPG, GIF, BMP, oder TIFF) hoch.',
			customize_appearance_title: 'Erscheinungsbild anpassen',
			customize_appearance_text:
				'Hier kannst du dein Wiki ganz nach deinen Vorstellungen und dein Unternehmensdesign anpassen.',
			company_logo_title: 'Unternehmens-Logo',
			company_logo_neg_title: 'Unternehmens-Logo (negativ)',
		},
		sidebar: {
			new_entry: 'Neuer Eintrag',
			new_subentry: 'Untereintrag erstellen',
			no_entries: 'Keine Einträge',
		},
		editor: {
			placeholder: 'Titel eingeben',
			click_to_add_block: 'Block unterhalb anlegen',
			click_for_options: 'Für weitere Optionen klicken',
			copy_section_link: 'Link zum Abschnitt kopieren',
			hint_success_label: 'Erfolg',
			hint_info_label: 'Info',
			hint_warning_label: 'Warnung',
			enter_link_url: 'URL eingeben',
			embed: 'Einfügen',
			link: 'Link setzen',
			no_image: 'Keine Bilddatei',
			type_to_add_elements: 'Tippe <b>/</b>, um Elemente anzulegen',
			invalid_url: 'Bitte gib eine gültige URL ein.',
			encrypt_file: 'Datei verschlüsseln',
			generating_preview: 'Vorschau erzeugen',
		},
		commands: {
			quickCommand: 'Kurzbefehl',
			mention: 'Erwähnung oder Link',
			emoji: 'Emoji',
			uploadImage: 'Bild einfügen',
			uploadFile: 'Datei einfügen',
			setHr: 'Trennstrich',
			setBold: 'Fett',
			setItalic: 'Kursiv',
			setLink: 'Link',
			setCode: 'Inline-Code',
			setHighlight: 'Hervorheben',
			setStrikedThrough: 'Durchstreichen',
			setParagraph: 'Absatz',
			setH2: 'Überschrift (groß)',
			setH3: 'Überschrift (klein)',
			setCodeBlock: 'Code-Block',
			setUnorderedList: 'Aufzählungsliste',
			setOrderedList: 'Nummerierte Liste',
			setCheckList: 'Checkliste',
			setHint: 'Hinweis',
			setBlockquote: 'Zitat',
			undo: 'Rückgängig machen',
			redo: 'Wiederholen',
			indent: 'Einzug in Liste verringern',
			unindent: 'Einzug in Liste vergrößern',
			moveUp: 'Block nach oben schieben',
			moveDown: 'Block nach unten schieben',
			createEntry: 'Neuen Eintrag erstellen',
			search: 'Suche',
			toggleSidebar: 'Seitenleiste ein-/ausklappen',
			openShortcutModal: 'Tastatur-Kurzbefehle',
			save: 'Speichern',
		},
		suggestions: {
			image: 'Bild',
			file: 'Datei',
			separator_line: 'Trennstrich',
			code_block: 'Code-Block',
			hint: 'Hinweis',
			table_of_contents: 'Inhaltsverzeichnis',
			page_index: 'Menü der Unterseiten',
			youtube: 'YouTube',
			vimeo: 'Vimeo',
			draw_io: 'Draw.io',
			figma: 'Figma',
			github_gist: 'GitHub Gist',
			codepen: 'Codepen',
			headline_large: 'Überschrift (groß)',
			headline_small: 'Überschrift (klein)',
			ordered_list: 'Nummerierte Liste',
			unordered_list: 'Aufzählungsliste',
			quote: 'Zitat',
			no_results: 'Keine Ergebnisse',
		},
		suggestion_groups: {
			advanced_blocks: 'Erweiterte Blöcke',
			embeds: 'Externe Inhalte einbetten',
			basic_blocks: 'Standard-Blöcke',
		},
		achievements: {
			FIRST_ARTICLE: {
				title: 'Ersten Eintrag erstellt',
				text: 'Der erste Eintrag ist immer der schwerste. Nicht.',
			},
			STRUCTURE_ENTRIES: {
				title: 'Ordnung ist das halbe Leben',
				text: 'Strukturiere dein Menü mit Drag & Drop.',
			},
			UPLOAD_PROFILE_PICTURE: {
				title: 'Zeig dein Gesicht',
				text:
					'Lade ein Bild von dir hoch, damit wir die Funktion nicht umsonst gebaut haben. Danke!',
				buttonText: 'Foto hinzufügen',
			},
			FIRST_RATING: {
				title: 'Bewerte einen Artikel',
				text:
					'Du hast deinen ersten Artikel bewertet. Aber es war nicht dein eigener, oder?',
			},
			FIRST_INVITATION_SENT: {
				title: 'Dein Team wächst',
				text:
					'Du hast erfolgreich dein erstes Teammitglied eingeladen. Hoffentlich nimmt er/sie die Einladung an!',
			},
			DARK_MODE_USED: {
				title: 'Dunkelmodus',
				text:
					'Du hast den Dunkelmodus verwendet. Bist du auch ein Fan, so wie wir?',
			},
			WORDS_WRITTEN_1000: {
				title: 'Schreib-Neuling',
				text:
					'Ein guter Anfang. Du hast bereits mehr als 1000 Wörter geschrieben.',
			},
			WORDS_WRITTEN_10000: {
				title: 'Vielschreiber',
				text:
					'Nicht schlecht. Du hast mehr als 10000 Wörter geschrieben.',
			},
			WORDS_WRITTEN_100000: {
				title: 'Joanne K. Rowling',
				text:
					'Alter, was ist los mit dir? Mit über 100000 Wörtern hast du fast ein ganzes Harry-Potter-Buch geschrieben.',
			},
			UPLOAD_TEAM_PICTURE: {
				title: 'Compliance-Kapitän',
				text: 'Firmenlogo in Skara hochgeladen. Erledigt.',
			},
			TEAM_SMALL: {
				title: 'Kleines Team',
				text: 'Dein Team wächst und gedeiht.',
			},
			TEAM_MEDIUM: {
				title: 'Mittleres Team',
				text:
					'10 Teammitglieder! Wenn du die nächste Errungenschaft freischalten willst, musst du nur 15 weitere Personen einstellen.',
			},
			TEAM_LARGE: {
				title: 'Großes Team',
				text:
					'Okay, okay, also sind auch 25 Teammitglieder kein Problem für dich. Die nächste Stufe wird kommen. Du kannst schon mal ein paar neue Stellenanzeigen schreiben. 😉',
			},
			SMILEYS_USED_10: {
				title: 'Emoji-Neuling',
				text:
					'Du hast mehr als 10 Emojis verwendet. Aber du schreibst schon auch noch Texte, oder? 🤓',
			},
			SMILEYS_USED_50: {
				title: 'Emoji-Experte',
				text:
					'Du hast mehr als 50 Emojis verwendet. Wird das mittlerweile in der Schule gelehrt? 🤔',
			},
			SMILEYS_USED_250: {
				title: 'Emoji-Profi',
				text:
					'Du hast mehr als 250 Emojis verwendet. Buchstaben sind nicht so deins, oder? 😂',
			},
			FIRST_REVISION_RESTORED: {
				title: 'Zurück in die Zukunft',
				text: 'Du hast eine Revision wiederhergestellt.',
			},
			LORD_OF_THE_RINGS: {
				title: 'Sauron-Bezwinger',
				text:
					'Was zum Teufel! Hast du ernsthaft so viele Worte geschrieben, wie die gesamte Herr-der-Ringe-Trilogie lang ist? Ähm, ja, das hast du.',
			},
			ARTICLES_DELETED_100: {
				title: 'Sternenzerstörer',
				text:
					'Du hast 100 Artikel gelöscht. Wir sind jetzt nicht ganz sicher, ob das gut oder schlecht ist.',
			},
			NIGHTLY_EDIT: {
				title: 'Nachteule',
				text:
					'So spät noch am arbeiten? Hoffentlich wirst du für die Überstunden bezahlt!',
			},
		},
		achievement_groups: {
			personal_achievements: 'Persönliche Erfolge',
			team_achievements: 'Team-Erfolge',
			hidden_achievements: 'Versteckte Erfolge',
		},
		status: {
			locked: 'Gesperrt',
			locked_long: 'Bearbeitung gesperrt..',
			locked_text: '%{name} bearbeitet momentan.',
			locked_by_oneself_text: 'Du bearbeitest momentan.',
			draft: 'Entwurf',
			outdated: 'Eintrag ist veraltet',
		},
		forms: {
			team_name: 'Name',
			team_url: 'Team-URL',
			change_team_url: 'Team-URL anpassen',
			change_url_notice:
				'Achtung! Wenn ihr die Team-URL verändert, werden alle Links, die ihr bisher irgendwo geteilt habt, nicht mehr funktionieren.',
			changed_url_title: 'Team-URL wurde angepasst',
			changed_url_text:
				'Die URL deines Teams wurde von einem Admin angepasst. Damit wir dich auf die neue URL leiten können, musst du die App bitte neuladen.',
			first_name: 'Vorname',
			last_name: 'Nachname',
			email: 'E-Mail',
			password: 'Passwort',
			sign_in: 'Einloggen',
			sign_in_to_your_account: 'melde dich jetzt an',
			sign_up_new_account: 'erstelle ein neues Benutzerkonto',
			sign_up_for_free: 'Kostenfrei registrieren',
			email_verification: 'E-Mail-Verifizierung',
			email_verification_text:
				'Wir haben dir eine E-Mail mit einem Aktivierungslink geschickt. Du hast keine Mail erhalten?',
			email_resend_verification_text:
				'Wir haben dir einen Aktivierungslink an die angegebene E-Mail Adresse geschickt.',
			email_resend_verification_button: 'Erneut senden',
			create_your_account: 'Benutzerkonto anlegen',
			by_registering_you_agree_to_our:
				'Mit der Registrierung akzeptierst du unsere',
			beta_key: 'Dein Beta-Code',
			not_signed_up_for_beta:
				'Du hast dich noch nicht für unsere Beta angemeldet? Kein Problem!',
			not_signed_up_for_beta_link: 'Jetzt für die Beta anmelden.',
			your_team: 'Dein Team',
			your_profile: 'Dein Profil',
			change_password: 'Passwort ändern',
			current_password: 'Aktuelles Passwort',
			enter_password: 'Passwort eingeben',
			new_password: 'Neues Passwort',
			enter_new_password: 'Neues Passwort eingeben',
			update_profile_image: 'Profilbild ändern',
			update_team_image: 'Team-Avatar ändern',
			image_requirements: 'Mindestgröße: 150 x 150 Pixel',
			please_select_valid_image: 'Bitte wähle ein gültiges Bild.',
			save_changes: 'Änderungen speichern',
			invitation: 'Team-Einladung',
			invitation_login_text:
				'Bitte logge dich mit deinem bestehenden Benutzerkonto ein, um der Team-Einladung zu folgen.',
			invitation_register_text:
				'Bitte registriere dich unterhalb, um deiner Einladung zu folgen.',
		},
		relative_time: {
			future: 'in %s',
			past: 'vor %s',
			s: 'ein paar Sekunden',
			ss: '%d Sekunden',
			m: 'einer Minute',
			mm: '%d Minuten',
			h: 'einer Stunde',
			hh: '%d Stunden',
			d: 'einem Tag',
			dd: '%d Tagen',
			M: 'einem Monat',
			MM: '%d Monaten',
			y: 'einem Jahr',
			yy: '%d Jahren',
		},
		errors: {
			'An internal server error occurred':
				'Ein interner Serverfehler ist aufgetreten.',
			connection_failed:
				'Es ist ein Fehler aufgetreten. Bitte versuche es in Kürze erneut.',
			wrong_team: 'Keine Teamzugehörigkeit gefunden.',
			user_not_found: 'Benutzer nicht gefunden.',
			email_password_invalid: 'E-Mail Adresse oder Passwort falsch.',
			error_occurred: 'Ein Fehler ist aufgetreten.',
			password_reset_token_invalid:
				'Der verwendete Passwort-Zurücksetzen-Link ist fehlerhaft oder abgelaufen.',
			account_inactive: 'Dein Account ist nicht aktiviert.',
			invalid_token: 'Fehlerhafter Sicherheitstoken.',
			user_already_active: 'Dein Account ist bereits aktiviert.',
			limit_exceeded: 'Limit überschritten.',
			password_weak: 'Dein Passwort ist zu schwach.',
			slug_taken: 'Es existiert bereits ein Account mit dieser URL.',
			email_taken:
				'Für diese E-Mail Adresse existiert bereits ein Account.',
			no_team: 'Der Benutzer ist in keinem Team.',
			confirm_email: 'Bitte bestätige deine E-Mail Adresse.',
			password_incorrect: 'Bitte prüfe das Passwort.',
			old_password_incorrect: 'Bitte prüfe das aktuelle Passwort.',
			article_not_found: 'Eintrag nicht gefunden.',
			articles_not_found: 'Einträge nicht gefunden.',
			no_permission: 'Fehlende Berechtigung.',
			revision_not_found: 'Revision nicht gefunden.',
			user_already_in_team: 'Dieser Benutzer ist bereits in deinem Team.',
			user_already_invited_to_team:
				'Dieser Benutzer wurde bereits in dein Team eingeladen.',
			invitation_not_found:
				'Einladung nicht gefunden. Bitte kontaktiere deinen Administrator bzgl. einer neuen Einladung.',
			invitation_unknown:
				'Einladung bezieht sich auf einen anderen Benutzer. Bitte logge dich aus und versuche es erneut.',
			update_own_role: 'Du kannst deine eigene Rolle nicht ändern.',
			wrong_voucher: 'Bitte verwende einen gültigen Gutscheincode.',
			required: 'Dieses Feld muss ausgefüllt werden.',
			minLength6: 'Dieses Feld muss mindestens 6 Zeichen enthalten.',
			invalid_email_address: 'Ungültige E-Mail-Adresse.',
		},
		cancel: 'Abbrechen',
		confirm: 'Bestätigen',
		close: 'Schließen',
		please_confirm: 'Bitte bestätigen',
		duplicate: 'Duplizieren',
		download: 'Herunterladen',
		delete: 'Löschen',
		delete_long: 'Ja, löschen!',
		delete_question:
			'Bist du sicher, dass du diesen Eintrag löschen möchtest?',
		tag_as_outdated_button: 'Eintrag als veraltet kennzeichnen',
		tag_as_outdated_text:
			'Bist du sicher, dass du diesen Eintrag als veraltet kennzeichnen möchtest? In diesem Fall werden alle für den Eintrag verantwortlichen Personen benachrichtigt.',
		tag_as_current_button: 'Eintrag ist wieder aktuell',
		tag_as_current_text:
			'Bist du sicher, dass du diesen Eintrag wieder als aktuell markieren möchtest?',
		back: 'Zurück',
		next: 'Weiter',
		add: 'Hinzufügen',
		add_member: 'Mitglied hinzufügen',
		add_me: 'Mich hinzufügen',
		editing_history: 'Revisionen',
		words: 'Wörter',
		characters: 'Zeichen',
		reading_time: 'Lesezeit',
		emojis: 'Emojis',
		created_at: 'Erstellt %{time}',
		updated_at: 'Aktualisiert %{time}',
		by_name: 'von %{name}',
		minutes_short: 'Min.',
		date_format: 'DD.MM.YYYY',
		date_and_time_format: 'DD.MM.YYYY, HH:mm',
		shortcuts: 'Kurzbefehle',
		formatting: 'Textformatierung',
		block_formatting: 'Blockformatierung',
		general: 'Allgemein',
		application: 'App',
		loading: 'Lädt …',
		no_data_found: 'Keine Daten gefunden',
		show_all_achievements: 'Alle Erfolge zeigen',
		error_404_big_text: 'Fehler %{status}',
		error_404_title: 'Hier stimmt was nicht.',
		error_404_text:
			'Die angeforderte Seite existiert nicht. Bist du sicher, dass die URL korrekt ist? Vielleicht wurde die Seite mittlerweile von deinem Team gelöscht. Am besten schaust du mal im Menü, ob du die Seite findest oder benutzt die Suche.',
		article_empty_state_big_text: 'Hä, wie jetzt?',
		article_empty_state_title: 'Noch keinen Eintrag erstellt?',
		article_empty_state_text:
			'Es ist noch kein Eintrag vorhanden. Du solltest dies schnell ändern, damit dein Wiki schon bald zu einer großen Wissenssammlung wird.',
		article_empty_state_cta:
			'Erstelle einen Eintrag mit der Schaltfläche auf der linken Seitenleiste oder drücke:',
		without_title: 'Ohne Titel',
		no_entries_found: 'Keine Einträge gefunden.',
		restore: 'Wiederherstellen',
		restore_revision: 'Revision wirklich wiederherstellen?',
		restore_revision_long:
			'Bist du sicher, dass du diese Revision wiederherstellen möchtest?',
		restore_revision_notice:
			'Übrigens wird der aktuelle Stand des Eintrags gespeichert, wenn du eine Revision wiederherstellst, damit nichts verloren geht.',
		preview: 'Vorschau',
		editing_history_text:
			'Jedes Mal, wenn dein Eintrag gespeichert wird und die letzte Revision älter als 30 Minuten ist, speichern wir eine neue Revision. Du hast jederzeit Zugriff auf alle jemals gespeicherten Revisionen. Es gibt kein Limit.',
		filter: 'Filtern',
		search_results: 'Suchergebnisse',
		no_search_results: 'Keine Suchergebnisse',
		search_placeholder: 'Tippe, um zu suchen',
		tour: 'Erste Schritte',
		feedback: 'Feedback',
		privacy_policy: 'Datenschutzerklärung',
		cookie_policy: 'Cookie-Richtlinie',
		legal_notice: 'Impressum',
		terms_of_service: 'Nutzungsbedingungen',
		or: 'oder',
		and: 'und',
		frontend_error_big_text: 'Oh nein …',
		frontend_error_title: 'Das tut uns Leid!',
		frontend_error_text:
			'Jetzt hast du dich endlich dazu durchgerungen, das Wiki zu benutzen. Und jetzt das. Eine heruntergefallene Eistüte. Wenn du die App schnell neu lädst, greift die 5-Sekunden-Regel und jemand kann das Eis aufheben und essen. 🤤',
		frontend_error_button: 'App neuladen',
		app_update_title: 'Skara wurde aktualisiert',
		app_update_text:
			'Wir haben Skara verbessert. Bitte lade die App neu, um von neuen Funktionen und behobenen Fehlern zu profitieren.',
		app_update_button: 'App neuladen',
		achievement_unlocked: 'Erfolg freigeschaltet',
		unsaved_message:
			'Es sieht so aus, als hättest du etwas bearbeitet. Wenn du die Seite verlässt, bevor der Eintrag gespeichert wurde, gehen deine Änderungen verloren.',
		deleted_user: 'Gelöschter Benutzer',
		onboarding_start: 'Fangen wir an!',
		responsible_persons: 'Verantwortliche Personen',
		responsible_persons_text:
			'Wähle einen oder mehrere Teammitglieder aus, die verantwortlich für diesen Eintrag sind.',
		creator: 'Ersteller',
		search_for_team_members: 'Nach Teammitgliedern suchen',
		all_members_selected: 'Es sind bereits alle Teammitglieder ausgewählt.',
		members: 'Teammitglieder',
		nobody_found: 'Niemand gefunden.',
		onboarding_intro_title: 'Willkommen,',
		onboarding_intro_text:
			'Wir zeigen dir kurz die Grundlagen, damit du dich schnell zurechtfindest. Ganz nebenbei wirst du deine ersten Erfolge freischalten.',
		onboarding_invite_title: 'Lade dein Team ein',
		onboarding_invite_text:
			'Dein Wiki wird erst so richtig effektiv, wenn es von deinem ganzen Team benutzt wird.',
		onboarding_profile_title: 'Lade ein Profilbild hoch 🤡',
		onboarding_profile_text:
			'So können deine Teammitglieder schneller erkennen, wer verantwortlich für einen Eintrag ist.',
		onboarding_entry_title: 'Erstelle deinen ersten Eintrag',
		onboarding_entry_text:
			'Und überleg dir eine gute Navigationsstruktur. Sie ist neben der Suche ein wesentlicher Faktor für das schnelle Finden von Informationen.',
		onboarding_style_title: 'Formatiere deinen Text',
		onboarding_style_text:
			'So ist er für andere schnell erfassbar und gesuchte Informationen können schneller gefunden werden.',
		onboarding_customize_title: 'Firmenlogo hochladen und Farben anpassen',
		onboarding_customize_text:
			'Integriere dein Wiki nahtlos in dein Unternehmen und verwende dein Logo und deine Unternehmensfarbe.',
		onboarding_outro_title: 'Jetzt bist du dran!',
		onboarding_outro_text:
			'Die Grundlagen kennst du jetzt. Um dein Wiki erfolgreich zu machen muss es nun mit Wissen gefüllt und genutzt werden.',
		download_app: 'Download macOS App',
		send_feedback: 'Feedback senden',
		give_feedback: 'Feedback geben',
		give_feedback_long: 'Feedback für diesen Eintrag geben',
		give_feedback_text:
			'Sende Feedback an die Verantwortlichen des Eintrags, um dein Wiki ständig zu verbessern.',
		your_feedback_message: 'Deine Nachricht',
		your_feedback_message_placeholder: 'Schreibe hier dein Feedback',
		feedback_sent: 'Dein Feedback wurde erfolgreich verschickt.',
		give_suggestion: 'Eintrag für fehlendes Thema vorschlagen',
		your_suggestion_message: 'Deine Nachricht',
		your_suggestion_message_placeholder:
			'Welcher Eintrag fehlt aktuell im Wiki?',
		suggestion_sent: 'Dein Vorschlag wurde erfolgreich verschickt.',
		send_suggestion: 'Vorschlag senden',
		suggestion_box_title: 'Nicht das richtige gefunden?',
		suggestion_box_text:
			'Jedes Mal, wenn du nicht fündig wirst, solltest du das fehlende Thema deinen Teammitgliedern vorschlagen, damit sich jemand darum kümmern kann.',
		suggestion_box_button: 'Neuen Eintrag vorschlagen',
		forgot_password: 'Passwort vergessen?',
		forgot_password_text:
			'Kein Problem, wir schicken dir eine Mail, damit du dein Passwort zurücksetzen kannst.',
		forgot_password_sent_text:
			'Wir haben dir einen Link geschickt, mit dem du dein Passwort zurücksetzen kannst.',
		forgot_password_reset_successfully:
			'Dein Passwort wurde erfolgreich geändert.',
		reset_password: 'Passwort zurücksetzen',
		reset_password_text:
			'Bitte geben Sie ein neues Passwort ein, um das alte zurückzusetzen. Anschließend können Sie sich mit Ihrem neuen Passwort wieder anmelden.',
		new_password: 'Neues Passwort',
		change_password: 'Passwort ändern',
		change: 'Anpassen',
	},
	en: {
		no_title: 'Untitled entry',
		settings: {
			settings: 'Settings',
			profile_tab: 'Profile',
			team_tab: 'Team',
			users_tab: 'Users',
			achievements_tab: 'Achievements',
			groups_tab: 'Groups',
			access_tab: 'Access rights',
			billing_tab: 'Billing',
			team_settings: 'Team settings',
			manage_members: 'Manage your members',
			invite_user: 'Invite user',
			invite_users: 'Invite users',
			invite_new_users: 'Invite new users',
			switch_team: 'Switch to team',
			create_team: 'Create team',
			create_new_team: 'Create new team',
			edit_profile: 'Edit your profile settings',
			theme: 'Dark mode',
			theme_description: "Because at night it's colder than outside.",
			reports: 'Email notifications',
			reports_description:
				'We will notify you regularly about new, possibly obsolete, and popular/unpopular entries.',
			update_profile: 'Update profile',
			sign_out: 'Sign out',
			user: 'User',
			user_description:
				'By default, users can invite new user but can’t manage other users’ roles or rights.',
			billing_admin: 'Billing admin',
			billing_admin_description:
				'Like regular users but with the ability to manage the billing details.',
			admin: 'Admin',
			admin_description:
				'Admins can invite new users and manage all roles and rights.',
			name: 'Name',
			status: 'Status',
			role: 'Role',
			invite_pending: 'Invite pending',
			active: 'Active',
			you: 'You',
			resend_invitation: 'Resend invitation',
			copy_link: 'Copy link',
			delete_invitation: 'Delete invitation',
			delete_invitation_text: 'You are about to delete this invitation.',
			delete_invitation_notice: 'This action is irrevocable!',
			delete_user: 'Delete user',
			delete_user_text: 'You are about to delete the user: ',
			delete_user_notice:
				'This action is irrevocable! Content created by the user is NOT deleted.',
			really_delete_invitation: 'Really delete invitation?',
			really_delete_user: 'Really delete user?',
			send_invites: 'Send invites',
			invites_large_team_text:
				'Big team? Just add multiple email addresses, separated by a comma or semicolon in the email field.',
			invites_large_team_link: '+ Add another invitation',
			auto_join: 'Auto join',
			auto_join_description:
				'Auto joining is disabled for your team. Users need to be invited manually.',
			team_domains: 'Domains',
			team_domains_description:
				"This is a list of the domains your team accepts by default. It is used for Auto join but also SSO if you set it up. It is a sensitive setting and shouldn't be changed lightly.",
			team_domains_notice:
				'Common public domains (e.g.: gmail.com,hotmail.com,…) will be stripped out.',
			team_domains_placeholder: 'A list of comma separated domains',
			upload_logo: 'Upload your logo',
			logo_light_requirements:
				'Upload your company logo (SVG, PNG, JPG), which works best on a white background.',
			logo_dark_requirements:
				'Upload your company logo (SVG, PNG, JPG), which works best on a dark background and is used in dark mode.',
			color_title: 'Color',
			favicon_title: 'Favicon',
			upload_favicon: 'Upload icon',
			favicon_requirements:
				'Upload a 32 x 32 pixel PNG, JPG, GIF, BMP, or TIFF to display in browser tabs.',
			customize_appearance_title: 'Customize appearance',
			customize_appearance_text:
				'Here you can customize your wiki according to your ideas and your company design.',
			company_logo_title: 'Company logo',
			company_logo_neg_title: 'Company logo (negative)',
		},
		sidebar: {
			new_entry: 'New entry',
			new_subentry: 'Create subentry',
			no_entries: 'No entries',
		},
		editor: {
			placeholder: 'Enter your title',
			click_to_add_block: 'Add a block below',
			click_for_options: 'Click for options',
			copy_section_link: 'Copy link to section',
			hint_success_label: 'Success',
			hint_info_label: 'Info',
			hint_warning_label: 'Warning',
			enter_link_url: 'Enter URL',
			embed: 'Embed',
			link: 'Link',
			no_image: 'No image file',
			type_to_add_elements: 'Type <b>/</b> to add elements',
			invalid_url: 'Please provide a valid url.',
			encrypt_file: 'Encrypt file',
			generating_preview: 'Generating preview',
		},
		commands: {
			quickCommand: 'Quick command',
			mention: 'Mention or link',
			emoji: 'Emoji',
			uploadImage: 'Upload image',
			uploadFile: 'Upload file',
			setHr: 'Separator line',
			setBold: 'Bold',
			setItalic: 'Italic',
			setLink: 'Link',
			setCode: 'Inline code',
			setHighlight: 'Highlight',
			setStrikedThrough: 'Strike through',
			setParagraph: 'Paragraph',
			setH2: 'Headline (large)',
			setH3: 'Headline (small)',
			setCodeBlock: 'Code block',
			setUnorderedList: 'Unordered list',
			setOrderedList: 'Ordered list',
			setCheckList: 'Check list',
			setHint: 'Hint',
			setBlockquote: 'Quote',
			undo: 'Undo',
			redo: 'Redo',
			indent: 'Indent list item',
			unindent: 'Unindent list item',
			moveUp: 'Move block up',
			moveDown: 'Move block down',
			createEntry: 'Create new entry',
			search: 'Search',
			toggleSidebar: 'Toggle sidebar',
			openShortcutModal: 'Keyboard shortcuts',
			save: 'Save',
		},
		suggestions: {
			image: 'Image',
			file: 'File',
			separator_line: 'Separator line',
			code_block: 'Code block',
			hint: 'Hint',
			table_of_contents: 'Table of contents',
			page_index: 'Page index',
			youtube: 'YouTube',
			vimeo: 'Vimeo',
			draw_io: 'Draw.io',
			figma: 'Figma',
			github_gist: 'GitHub Gist',
			codepen: 'Codepen',
			headline_large: 'Headline (large)',
			headline_small: 'Headline (small)',
			ordered_list: 'Ordered list',
			unordered_list: 'Unordered list',
			quote: 'Quote',
			no_results: 'No results',
		},
		suggestion_groups: {
			advanced_blocks: 'Advanced blocks',
			embeds: 'Embedding external content',
			basic_blocks: 'Basic blocks',
		},
		achievements: {
			FIRST_ARTICLE: {
				title: 'First entry created',
				text: 'The first entry is always the most difficult. Not.',
			},
			STRUCTURE_ENTRIES: {
				title: 'Order is half of life',
				text: 'Structure your menu with drag & drop.',
			},
			UPLOAD_PROFILE_PICTURE: {
				title: 'Show your face',
				text:
					'Upload a picture of yourself, so we don’t build the function for nothing. Thanks!',
				buttonText: 'Add a photo',
			},
			FIRST_RATING: {
				title: 'Rate an article for the first time',
				text:
					'You rated your first article. But it wasn’t your own, was it?',
			},
			FIRST_INVITATION_SENT: {
				title: 'Your team is growing',
				text:
					'You have successfully invited your first team member. Hopefully, he/she accepts the invitation!',
			},
			DARK_MODE_USED: {
				title: 'Dark mode',
				text: 'You used dark mode. Are you also a fan, like us?',
			},
			WORDS_WRITTEN_1000: {
				title: 'Writing novice',
				text:
					'A good start. You have already written more than 1000 words.',
			},
			WORDS_WRITTEN_10000: {
				title: 'Frequent writer',
				text: 'Not bad. You have written more than 10000 words.',
			},
			WORDS_WRITTEN_100000: {
				title: 'Joanne K. Rowling',
				text:
					'Dude, what’s up with you? With over 100000 words you have written almost an entire Harry Potter book.',
			},
			UPLOAD_TEAM_PICTURE: {
				title: 'Compliance captain',
				text: 'Company logo uploaded in Skara. Check.',
			},
			TEAM_SMALL: {
				title: 'Small team',
				text: 'Your team grows and prospers.',
			},
			TEAM_MEDIUM: {
				title: 'Medium team',
				text:
					'10 team members! If you want to unlock the next achievement, you only need to hire 15 more people.',
			},
			TEAM_LARGE: {
				title: 'Large team',
				text:
					'Okay, okay, so even 25 team members are no problem for you. Another achievement is coming. You can start writing some new job ads. 😉',
			},
			SMILEYS_USED_10: {
				title: 'Emoji novice',
				text:
					'You’ve used more than 10 Emojis. But you write lyrics as well, don’t you? 🤓',
			},
			SMILEYS_USED_50: {
				title: 'Emoji expert',
				text:
					'You’ve used more than 50 Emojis. Is this now taught in school? 🤔',
			},
			SMILEYS_USED_250: {
				title: 'Emoji professional',
				text:
					'You’ve used more than 250 Emojis. Letters aren’t yours, are they? 😂',
			},
			FIRST_REVISION_RESTORED: {
				title: 'Back to the future',
				text: 'You restored a revision.',
			},
			LORD_OF_THE_RINGS: {
				title: 'Sauron conqueror',
				text:
					'What the heck! Have you seriously written as many words as the complete Lord of the Rings trilogy is long? Um, yes, you did.',
			},
			ARTICLES_DELETED_100: {
				title: 'Star destroyer',
				text:
					'You deleted 100 articles. We are not sure whether this is good or bad.',
			},
			NIGHTLY_EDIT: {
				title: 'Night owl',
				text:
					'Working this late? Well, hopefully, you will get paid for the overtime!',
			},
		},
		achievement_groups: {
			personal_achievements: 'Personal achievements',
			team_achievements: 'Team achievements',
			hidden_achievements: 'Hidden achievements',
		},
		status: {
			locked: 'Locked',
			locked_long: 'Editing locked.',
			locked_text: '%{name} is currently editing.',
			locked_by_oneself_text: 'You are currently editing.',
			draft: 'Draft',
			outdated: 'Entry is obsolete',
		},
		forms: {
			team_name: 'Name',
			team_url: 'Team URL',
			change_team_url: 'Change team URL',
			change_url_notice:
				'Attention! If you change the team URL, all the links you have shared anywhere so far will no longer work.',
			changed_url_title: 'Team URL was changed',
			changed_url_text:
				'The URL of your team has been changed by an admin. In order for us to redirect you to the new URL, please reload the app.',
			first_name: 'First name',
			last_name: 'Last name',
			email: 'Email',
			password: 'Password',
			sign_in: 'Sign in',
			sign_in_to_your_account: 'sign in to your account',
			sign_up_new_account: 'sign up a new account',
			sign_up_for_free: 'Sign up for free',
			email_verification: 'Email verification',
			email_verification_text:
				'We have sent you an email with an activation link. You have not received one?',
			email_resend_verification_text:
				'We have sent you an activation link to the given email address.',
			email_resend_verification_button: 'Send again',
			create_your_account: 'Create your account',
			by_registering_you_agree_to_our: 'By registering, you agree to our',
			beta_key: 'Your beta key',
			not_signed_up_for_beta:
				'Have you not yet signed up for our beta? No problem!',
			not_signed_up_for_beta_link: 'Get early access now.',
			your_team: 'Your team',
			your_profile: 'Your profile',
			change_password: 'Change password',
			current_password: 'Current password',
			enter_password: 'Enter your password',
			new_password: 'New password',
			enter_new_password: 'Enter your new password',
			update_profile_image: 'Update profile picture',
			update_team_image: 'Update team avatar',
			image_requirements: 'Minimum size: 150 x 150 pixels',
			please_select_valid_image: 'Please select a valid image.',
			save_changes: 'Save changes',
			invitation_login: 'Invitation',
			invitation_login_text:
				'Please log in with your existing user account to follow the team invitation.',
			invitation_register: 'Invitation',
			invitation_register_text:
				'Please register below to follow your invitation.',
		},
		relative_time: {
			future: 'in %s',
			past: '%s ago',
			s: 'a few seconds',
			ss: '%d seconds',
			m: 'a minute',
			mm: '%d minutes',
			h: 'an hour',
			hh: '%d hours',
			d: 'a day',
			dd: '%d days',
			M: 'a month',
			MM: '%d months',
			y: 'a year',
			yy: '%d years',
		},
		errors: {
			'An internal server error occurred':
				'An internal server error occurred.',
			connection_failed:
				'There was an error connecting to the server. Please try again in a few.',
			wrong_team: 'No team membership found.',
			user_not_found: 'User not found.',
			email_password_invalid: 'Email address or password is invalid.',
			error_occurred: 'An error occurred.',
			password_reset_token_invalid:
				'The password reset token you are using is invalid or has expired',
			account_inactive: 'Your account is not activated.',
			invalid_token: 'Invalid token.',
			user_already_active: 'Your account is activated already.',
			limit_exceeded: 'Request limit exceeded.',
			password_weak: 'Your password is not strong enough.',
			slug_taken:
				'There is already an existing account with the same team slug.',
			email_taken:
				'There is already an existing account with the same email address.',
			no_team: 'The user seems to be not a part of any team.',
			confirm_email: 'Please confirm your email address.',
			password_incorrect: 'The password is not correct.',
			old_password_incorrect: 'The current password is not correct.',
			article_not_found: 'Entry not found.',
			articles_not_found: 'Entries not found.',
			no_permission: 'No permission.',
			revision_not_found: 'Revision not found.',
			user_already_in_team: 'That user is already part of the team.',
			user_already_invited_to_team:
				'That user is already invited to the team.',
			invitation_not_found:
				'Invitation not found. Please contact your admin for a new invitation.',
			invitation_unknown:
				'Invitation is not meant for your account. Please logout and try again.',
			update_own_role: "You can't change your own role.",
			wrong_voucher: 'Please provide a valid key.',
			required: 'This field must be filled in.',
			minLength6: 'Must be 6 characters or more.',
			invalid_email_address: 'Invalid email address',
		},
		cancel: 'Cancel',
		confirm: 'Confirm',
		close: 'Close',
		please_confirm: 'Please confirm',
		duplicate: 'Duplicate',
		download: 'Download',
		delete: 'Delete',
		delete_long: 'Yes, delete!',
		delete_question: 'Are you sure you want to delete this entry?',
		tag_as_outdated_button: 'Mark entry as obsolete',
		tag_as_outdated_text:
			'Are you sure you want to mark this entry as obsolete? If so, all persons responsible for the entry will be notified.',
		tag_as_current_button: 'Entry is up-to-date again',
		tag_as_current_text:
			'Are you sure you want to mark this entry as current again?',
		back: 'Back',
		next: 'Next',
		add: 'Add',
		add_member: 'Add member',
		add_me: 'Add me',
		editing_history: 'Editing history',
		words: 'Words',
		characters: 'Characters',
		reading_time: 'Reading time',
		emojis: 'Emojis',
		created_at: 'Created %{time}',
		updated_at: 'Updated %{time}',
		by_name: 'by %{name}',
		minutes_short: 'min',
		date_format: 'MMMM Do YYYY',
		date_and_time_format: 'MMMM Do YYYY, h:mm A',
		shortcuts: 'Shortcuts',
		formatting: 'Text formatting',
		block_formatting: 'Block formatting',
		general: 'General',
		application: 'Application',
		loading: 'Loading …',
		no_data_found: 'No data found',
		show_all_achievements: 'Show all achievements',
		error_404_big_text: 'Error %{status}',
		error_404_title: 'Something’s wrong.',
		error_404_text:
			'The requested page does not exist. Are you sure that the URL is correct? Maybe the page has been deleted by your team by now. The best thing to do is check the menu to see if you can find the page or use the search.',
		article_empty_state_big_text: 'Wait, what?',
		article_empty_state_title: 'No entry created yet?',
		article_empty_state_text:
			'There is actually no entry available yet. You should change this very fast, so that your Wiki becomes a large knowledge collection quite soon.',
		article_empty_state_cta:
			'Create an entry using the button on the left or press this:',
		without_title: 'Without title',
		no_entries_found: 'No entries found.',
		restore: 'Restore',
		restore_revision: 'Really restore revision?',
		restore_revision_long:
			'Are you sure you want to restore the following revision?',
		restore_revision_notice:
			'By the way, when restoring a revision, we save the current state of the entry so that nothing can get lost.',
		preview: 'Preview',
		editing_history_text:
			'Each time your entry is saved and the last revision is older than 30 minutes, we save a new revision. You always have access to all revisions ever saved. There is no limit.',
		filter: 'Filter',
		search_results: 'Search results',
		no_search_results: 'No search results',
		search_placeholder: 'Type to search',
		tour: 'First steps',
		feedback: 'Feedback',
		privacy_policy: 'Privacy policy',
		cookie_policy: 'Cookie policy',
		legal_notice: 'Legal notice',
		terms_of_service: 'Terms of service',
		or: 'or',
		and: 'and',
		frontend_error_big_text: 'Oh no …',
		frontend_error_title: 'We sincerely apologize!',
		frontend_error_text:
			'Now you have finally made up your mind to use the wiki. And now this. A dropped ice cream cone. If you reload the app quickly, the 5-second rule kicks in and someone can pick up the ice cream and eat it. 🤤',
		frontend_error_button: 'Reload the app',
		app_update_title: 'Skara was updated',
		app_update_text:
			'We have improved Skara. Please reload the app to benefit from new features and fixed bugs.',
		app_update_button: 'Reload the app',
		achievement_unlocked: 'Achievement unlocked',
		unsaved_message:
			'It looks like you have been editing something. If you leave the page before the entry is saved, your changes will be lost.',
		deleted_user: 'Deleted user',
		onboarding_start: "Let's start!",
		responsible_persons: 'Responsible persons',
		responsible_persons_text:
			'Select one or more team members who are responsible for this entry.',
		creator: 'Creator',
		search_for_team_members: 'Search for team members',
		all_members_selected: 'All team members are already selected.',
		members: 'members',
		nobody_found: 'Nobody found.',
		onboarding_intro_title: 'Welcome,',
		onboarding_intro_text:
			'We will briefly show you the basics so that you can quickly find your way around. At the same time you will unlock your first achievements.',
		onboarding_invite_title: 'Invite your team ',
		onboarding_invite_text:
			'Your wiki only becomes really effective when it is used by your whole team.',
		onboarding_profile_title: 'Upload profile picture 🤡',
		onboarding_profile_text:
			'This allows your team members to see more quickly who is responsible for an entry.',
		onboarding_entry_title: 'Add your first entry',
		onboarding_entry_text:
			'And think of a good navigation structure. Besides the search, it is an essential factor for finding information quickly.',
		onboarding_style_title: 'Format your text',
		onboarding_style_text:
			'This makes it quickly comprehensible for others and allows them to find the information they are looking for more quickly.',
		onboarding_customize_title: 'Upload company logo and customize colors',
		onboarding_customize_text:
			'Integrate your wiki seamlessly into your company and use your logo and corporate color.',
		onboarding_outro_title: 'Now it’s your turn!',
		onboarding_outro_text:
			'You know the basics now. To make your wiki successful, it must now be filled with knowledge and used.',
		download_app: 'Download macOS app',
		send_feedback: 'Send feedback',
		give_feedback: 'Give feedback',
		give_feedback_long: 'Give feedback for this entry',
		give_feedback_text:
			'Send feedback to the people responsible for the entry to constantly improve your wiki.',
		your_feedback_message: 'Your message',
		your_feedback_message_placeholder: 'Write your feedback here',
		feedback_sent: 'Your feedback was sent successfully.',
		give_suggestion: 'Suggest entry for missing topic',
		your_suggestion_message: 'Your message',
		your_suggestion_message_placeholder:
			'Which entry is currently missing from the Wiki?',
		suggestion_sent: 'Your suggestion was sent successfully.',
		send_suggestion: 'Send suggestion',
		suggestion_box_title: 'Not found the right thing?',
		suggestion_box_text:
			'Every time you don’t find what you are looking for, you should suggest the missing topic to your team members so that someone can take care of it.',
		suggestion_box_button: 'Suggest new entry',
		forgot_password: 'Forgot password?',
		forgot_password_text:
			'No problem, we will send you an email so you can reset your password.',
		forgot_password_sent_text:
			'We have sent you a link which will allow you to reset your password.',
		forgot_password_reset_successfully:
			'Your password has been successfully changed!',
		reset_password: 'Reset password',
		reset_password_text:
			'Please enter a new password to reset the old one. afterwards you are able to sign in again with your new password.',
		new_password: 'New password',
		change_password: 'Change password',
		change: 'Change',
	},
})

export default getPhrases
